// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBVgHw8GMS5QpV30idAkoovZPVeXyGjdl4',
    authDomain: 'mcs-online-teaching.firebaseapp.com',
    databaseURL: 'https://mcs-online-teaching.firebaseio.com',
    projectId: 'mcs-online-teaching',
    storageBucket: 'mcs-online-teaching.appspot.com',
    messagingSenderId: '231179172254',
    appId: '1:231179172254:web:f7e67bb1c8a14e91857e8f',
    measurementId: 'G-4ERTYYG4X0',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
